import React, { useState } from "react";
import { FaCopy, FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import {AIRTABLE_URL, AIRTABLE_HEADERS,} from "./constants"; // ✅ import constants

const ShareButton = () => {
  const [copied, setCopied] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [showReferrals, setShowReferrals] = useState(false);
  const [referrals, setReferrals] = useState([]);

  const userPhone = localStorage.getItem("userPhone") || "";

  const fetchReferralData = async () => {
    try {
      const res = await fetch(`${AIRTABLE_URL}?filterByFormula={referralby}='${userPhone}'`, {
        headers: AIRTABLE_HEADERS,
      });
      const data = await res.json();
      setReferrals(data.records || []);
    } catch (err) {
      console.error("Failed to fetch referral data:", err);
    }
  };


  const toggleReferrals = () => {
    const newValue = !showReferrals;
    setShowReferrals(newValue);
    if (newValue && referrals.length === 0) {
      fetchReferralData();
    }
  };

  const shareUrl = `https://play.google.com/store/apps/details?id=com.coolfix.app&referredby=${userPhone}`;
  const shareText = `Check out the CoolFix app for fast and reliable AC repairs and services. Get any AC-related issue fixed quickly!\n\nRefer and earn ₹50 when your friend completes a paid service.`;

  const handleShareWrapper = async (shareMethod) => {
    shareMethod();
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "CoolFix AC Service",
          text: shareText,
          url: shareUrl,
        });
      } catch (error) {
        console.error("Share failed:", error);
      }
    } else {
      handleCopyLink();
    }
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      alert("Failed to copy. Please copy manually: " + shareUrl);
    }
  };

  const openWhatsApp = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(shareText + " " + shareUrl)}`;
    window.open(url, "_blank");
  };

  const openTelegram = () => {
    const url = `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
    window.open(url, "_blank");
  };

  return (
    <div style={{ textAlign: "center", marginTop: "60px" }}>
      <div style={{ fontSize: "16px", color: "#333", fontWeight: "bold", marginBottom: "15px" }}>
        Share our app and earn ₹50 when your referral installs and books a service for the first time!
      </div>

      <div style={{ display: "flex", marginTop: "30px" }}>
        <button
          onClick={() => handleShareWrapper(handleNativeShare)}
          style={{
            backgroundColor: "#007bff",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            marginBottom: "10px",
            marginTop: "20px",
          }}
        >
          📤 Share App
        </button>
      </div>

      <div style={{ marginTop: 10, display: "flex", gap: 15 }}>
        <button onClick={() => handleShareWrapper(openWhatsApp)} title="Share on WhatsApp"
          style={{ backgroundColor: "#25D366", color: "#fff", border: "none", borderRadius: "50%", width: 40, height: 40, fontSize: 20, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <FaWhatsapp />
        </button>
        <button onClick={() => handleShareWrapper(openTelegram)} title="Share on Telegram"
          style={{ backgroundColor: "#0088cc", color: "#fff", border: "none", borderRadius: "50%", width: 40, height: 40, fontSize: 20, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <FaTelegramPlane />
        </button>
        <button onClick={() => handleShareWrapper(handleCopyLink)} title="Copy link"
          style={{ backgroundColor: "#555", color: "#fff", border: "none", borderRadius: "50%", width: 40, height: 40, fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <FaCopy />
        </button>
      </div>

      {copied && (
        <div style={{ marginTop: 8, color: "green", fontWeight: "bold", fontSize: "14px" }}>
          ✅ Link copied to clipboard!
        </div>
      )}

      {/* Toggle Referral Policy */}
      <div style={{ marginTop: "2px" }}>
        <button
          onClick={() => setShowPolicy((prev) => !prev)}
          style={{
            backgroundColor: "#007bff",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            marginBottom: "10px",
            marginTop: "20px",
          }}
        >
          {showPolicy ? "Hide Referral Policy" : "View Referral Policy"}
        </button>

        {showPolicy && (
          <div style={{
            marginTop: 20,
            backgroundColor: "#f9f9f9",
            padding: 15,
            borderRadius: 6,
            textAlign: "left",
            maxWidth: 600,
            margin: "20px auto",
            fontSize: "14px",
            lineHeight: 1.6,
            border: "1px solid #ddd"
          }}>
            <strong>Referral Policy:</strong>
            <ul style={{ paddingLeft: 20, marginTop: 10 }}>
              <li>You will earn ₹50 only if the referred user enters your phone number in the referral field.</li>
              <li>The referred user must be new and should book and complete their first paid service.</li>
              <li>Cancelled or rejected bookings will not be considered.</li>
              <li>You can share the app with multiple users, but you will earn rewards only for valid first-time paid referrals.</li>
              <li>Your reward will be transferred to your registered phone number after verification.</li>
            </ul>
          </div>
        )}
      </div>

      {/* Toggle Referral History */}
      <div style={{ marginTop: "1px" }}>
        <button
          onClick={toggleReferrals}
          style={{
             backgroundColor: "#007bff",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            marginBottom: "10px",
            marginTop: "20px",
          }}
        >
          {showReferrals ? "Hide Referral History" : "View Referral History"}
        </button>

        {showReferrals && (
          <div style={{
            marginTop: 20,
            backgroundColor: "#f1f1f1",
            padding: 15,
            borderRadius: 6,
            maxWidth: 600,
            margin: "20px auto",
            fontSize: "14px",
            textAlign: "left",
            border: "1px solid #ccc"
          }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>Referred Phone</th>
                  <th style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>Book a Service and Paid</th>
                  <th style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>Earning</th>
                </tr>
              </thead>
              <tbody>
                {referrals.length > 0 ? (
                  referrals.map((ref, index) => (
                    <tr key={index}>
                      <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{ref.fields.phone || "-"}</td>
                      <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{ref.fields.paid ? "Yes" : "No"}</td>
                      <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{ref.fields.earning || "0"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" style={{ padding: "10px", textAlign: "center" }}>No referrals found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareButton;
